// assets/src/js/why-testimonial.js
(function (Drupal, once) {
  Drupal.behaviors.keidoWhyTestimonial = {
    attach(context) {
      once("keido-why-testimonial", ".k-why-testimonial", context).forEach(
        (section) => {
          // Find a container inside the right column that holds multiple rows
          const quoteContainer =
            section.querySelector(".k-quote-col .view-content") ||
            section.querySelector(".k-quote-col .js-view-dom-id") ||
            section.querySelector(".k-quote-col .views-element-container");

          if (!quoteContainer) return;

          // Slides = each Views row
          const slides = Array.from(
            quoteContainer.querySelectorAll(".views-row")
          );
          if (slides.length <= 1) return; // nothing to rotate yet

          quoteContainer.classList.add("k-quote-rotator");
          let index = 0;
          slides.forEach((el, i) => el.classList.toggle("is-active", i === 0));

          // Build dots UI
          const dotsWrap = section.querySelector(".k-quote-dots");
          if (dotsWrap) {
            dotsWrap.innerHTML = "";
            slides.forEach((_, i) => {
              const b = document.createElement("button");
              b.type = "button";
              b.setAttribute("aria-label", `Show testimonial ${i + 1}`);
              if (i === 0) b.setAttribute("aria-current", "true");
              b.addEventListener("click", () => goTo(i, true));
              dotsWrap.appendChild(b);
            });
          }

          function goTo(i, userInitiated) {
            slides[index].classList.remove("is-active");
            const prevDot = dotsWrap?.children[index];
            prevDot?.removeAttribute("aria-current");

            index = (i + slides.length) % slides.length;

            slides[index].classList.add("is-active");
            const currDot = dotsWrap?.children[index];
            currDot?.setAttribute("aria-current", "true");

            if (userInitiated) resetTimer(true);
          }

          const INTERVAL = 6000;
          let timer = null;
          function tick() {
            goTo(index + 1, false);
          }
          function resetTimer(pauseOnce) {
            clearInterval(timer);
            timer = setInterval(tick, INTERVAL);
            if (pauseOnce) {
              setTimeout(() => {
                clearInterval(timer);
                timer = setInterval(tick, INTERVAL);
              }, INTERVAL * 1.2);
            }
          }
          resetTimer(false);

          // A11y landmark
          quoteContainer.setAttribute("role", "region");
          quoteContainer.setAttribute("aria-label", "Testimonials");
        }
      );
    },
  };
})(Drupal, once);
